<template>
  <div>
    <h1>{{ $t('corporate.career') }}</h1>
    <h3>
      Aktif pozisyonlarımıza
      <a href="https://www.linkedin.com/company/onedio/jobs/" target="_blank">&nbsp;LinkedIn&nbsp;</a>
      üzerinden ulaşabilirsiniz.
    </h3>
  </div>
</template>
<script>
import { defineComponent, useContext } from '@nuxtjs/composition-api';
import pageHeader from '@/constants/pageHeaders';
export default defineComponent({
  head() {
    return pageHeader('career');
  },
  setup() {
    const { $cache } = useContext();
    $cache('public, max-age=60');
    return {};
  },
});
</script>
